enum ActionType {
    RECEIVE_AUTH_TOKEN = '[CORE/AUTH] SET TOKEN',
    SET_MSAL = '[CORE/AUTH] SET MSAL',
    CLEAR_MSAL = '[CORE/AUTH] CLEAR MSAL',
    CLEAR_AUTH_TOKEN = '[CORE/AUTH] CLEAR_AUTH_TOKEN',
}

export default ActionType
